/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Edit_Title_CancelInputs */

const cs_chat_edit_title_cancel = /** @type {(inputs: Chat_Edit_Title_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zrušit`)
};

const en_chat_edit_title_cancel = /** @type {(inputs: Chat_Edit_Title_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Chat_Edit_Title_CancelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_edit_title_cancel = /** @type {((inputs?: Chat_Edit_Title_CancelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Edit_Title_CancelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_edit_title_cancel(inputs)
	return cs_chat_edit_title_cancel(inputs)
});